import 'svelte/internal/disclose-version';

SessionSummary[$.FILENAME] = 'src/ui/SessionSummary.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations($.from_html(`<p class="note svelte-i77pfhz3anbp">Nothing saved</p>`), SessionSummary[$.FILENAME], [[21, 22]]);
var root_1 = $.add_locations($.from_html(`<p class="note svelte-i77pfhz3anbp"> </p>`), SessionSummary[$.FILENAME], [[22, 20]]);

var root_2 = $.add_locations(
	$.from_html(
		`
        <li class="svelte-i77pfhz3anbp">
          <span class="prompt svelte-i77pfhz3anbp" lang="zh-Hans"> </span>
          <span class="kind svelte-i77pfhz3anbp"> </span>
          <span class="when svelte-i77pfhz3anbp"> </span>
        </li>
      `,
		1
	),
	SessionSummary[$.FILENAME],
	[[28, 8, [[29, 10], [30, 10], [31, 10]]]]
);

var root_3 = $.add_locations(
	$.from_html(
		`
    <h3 class="svelte-i77pfhz3anbp">Coming back</h3>
    <ul class="coming svelte-i77pfhz3anbp">
      <!>
    </ul>
  `,
		1
	),
	SessionSummary[$.FILENAME],
	[[25, 4], [26, 4]]
);

var root_4 = $.add_locations(
	$.from_html(
		`
        <li class="svelte-i77pfhz3anbp">
          <span class="prompt svelte-i77pfhz3anbp" lang="zh-Hans"> </span>
          <span class="kind svelte-i77pfhz3anbp"> </span>
          <span class="answer"> </span>
          <s class="given svelte-i77pfhz3anbp"> </s>
        </li>
      `,
		1
	),
	SessionSummary[$.FILENAME],
	[[41, 8, [[42, 10], [43, 10], [44, 10], [45, 10]]]]
);

var root_5 = $.add_locations(
	$.from_html(
		`
    <h3 class="svelte-i77pfhz3anbp">Missed</h3>
    <ul class="missed svelte-i77pfhz3anbp">
      <!>
    </ul>
  `,
		1
	),
	SessionSummary[$.FILENAME],
	[[38, 4], [39, 4]]
);

var root_6 = $.add_locations(
	$.from_html(
		`
    <h3 class="svelte-i77pfhz3anbp">Correct</h3>
    <p class="right svelte-i77pfhz3anbp" lang="zh-Hans"> </p>
  `,
		1
	),
	SessionSummary[$.FILENAME],
	[[52, 4], [53, 4]]
);

var root_7 = $.add_locations(
	$.from_html(
		`
    <h3 class="svelte-i77pfhz3anbp">Not saved</h3>
    <p class="note svelte-i77pfhz3anbp"> </p>
  `,
		1
	),
	SessionSummary[$.FILENAME],
	[[57, 4], [58, 4]]
);

var root_8 = $.add_locations($.from_html(`<kbd>Enter</kbd>`), SessionSummary[$.FILENAME], [[66, 15]]);

var root_9 = $.add_locations(
	$.from_html(
		`

<section class="summary svelte-i77pfhz3anbp" aria-labelledby="summary-title">
  <h2 id="summary-title" class="hidden svelte-i77pfhz3anbp">Session summary</h2>
  <p class="set svelte-i77pfhz3anbp"> </p>
  <!>
  <!>

  <!>

  <!>

  <!>

  <!>

  <!-- TODO: Accept detail=0 here and on Continue/End; suppress duplicate key clicks and supply key/Alt handling in standalone stories. -->
  <button type="button">
    Back to sets
    <!>
  </button>
</section>

`,
		1
	),
	SessionSummary[$.FILENAME],
	[[18, 0, [[19, 2], [20, 2], [64, 2]]]]
);

export default function SessionSummary($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, SessionSummary);

	let hints = $.prop($$props, 'hints', 3, false),
		pressed = $.prop($$props, 'pressed', 3, false);

	let back = $.tag($.state(void 0), 'back');

	$.user_effect(() => $.get(back)?.focus());

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_9();
	var section = $.sibling($.first_child(fragment));
	var p = $.sibling($.child(section), 3);
	var text = $.only_child(p, true);
	var node = $.sibling(p, 2);

	{
		var consequent = ($$anchor) => {
			var p_1 = root();

			$.append($$anchor, p_1);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$$props.summary.saved) $$render(consequent);
			}),
			'if',
			SessionSummary,
			21,
			2
		);
	}

	var node_1 = $.sibling(node, 2);

	{
		var consequent_1 = ($$anchor) => {
			var p_2 = root_1();
			var text_1 = $.only_child(p_2, true);

			$.template_effect(() => $.set_text(text_1, $$props.summary.next));
			$.append($$anchor, p_2);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if ($$props.summary.next) $$render(consequent_1);
			}),
			'if',
			SessionSummary,
			22,
			2
		);
	}

	var node_2 = $.sibling(node_1, 2);

	{
		var consequent_2 = ($$anchor) => {
			var fragment_1 = root_3();
			var ul = $.sibling($.first_child(fragment_1), 3);
			var node_3 = $.sibling($.child(ul));

			$.add_svelte_meta(
				() => $.each(node_3, 17, () => $$props.summary.coming, $.index, ($$anchor, row) => {
					$.next();

					var fragment_2 = root_2();
					var li = $.sibling($.first_child(fragment_2));
					var span = $.sibling($.child(li));
					var text_2 = $.only_child(span, true);
					var span_1 = $.sibling(span, 2);
					var text_3 = $.only_child(span_1, true);
					var span_2 = $.sibling(span_1, 2);
					var text_4 = $.only_child(span_2, true);

					$.next();
					$.reset(li);
					$.next();

					$.template_effect(() => {
						$.set_text(text_2, $.get(row).prompt);
						$.set_text(text_3, $.get(row).kind);
						$.set_text(text_4, $.get(row).when);
					});

					$.append($$anchor, fragment_2);
				}),
				'each',
				SessionSummary,
				27,
				6
			);

			$.next();
			$.reset(ul);
			$.next();
			$.append($$anchor, fragment_1);
		};

		$.add_svelte_meta(
			() => $.if(node_2, ($$render) => {
				if ($$props.summary.coming.length) $$render(consequent_2);
			}),
			'if',
			SessionSummary,
			24,
			2
		);
	}

	var node_4 = $.sibling(node_2, 2);

	{
		var consequent_3 = ($$anchor) => {
			var fragment_3 = root_5();
			var ul_1 = $.sibling($.first_child(fragment_3), 3);
			var node_5 = $.sibling($.child(ul_1));

			$.add_svelte_meta(
				() => $.each(node_5, 17, () => $$props.summary.missed, $.index, ($$anchor, row) => {
					$.next();

					var fragment_4 = root_4();
					var li_1 = $.sibling($.first_child(fragment_4));
					var span_3 = $.sibling($.child(li_1));
					var text_5 = $.only_child(span_3, true);
					var span_4 = $.sibling(span_3, 2);
					var text_6 = $.only_child(span_4, true);
					var span_5 = $.sibling(span_4, 2);
					var text_7 = $.only_child(span_5, true);
					var s = $.sibling(span_5, 2);
					var text_8 = $.only_child(s, true);

					$.next();
					$.reset(li_1);
					$.next();

					$.template_effect(() => {
						$.set_text(text_5, $.get(row).prompt);
						$.set_text(text_6, $.get(row).kind);
						$.set_text(text_7, $.get(row).answer);
						$.set_text(text_8, $.get(row).given);
					});

					$.append($$anchor, fragment_4);
				}),
				'each',
				SessionSummary,
				40,
				6
			);

			$.next();
			$.reset(ul_1);
			$.next();
			$.append($$anchor, fragment_3);
		};

		$.add_svelte_meta(
			() => $.if(node_4, ($$render) => {
				if ($$props.summary.missed.length) $$render(consequent_3);
			}),
			'if',
			SessionSummary,
			37,
			2
		);
	}

	var node_6 = $.sibling(node_4, 2);

	{
		var consequent_4 = ($$anchor) => {
			var fragment_5 = root_6();
			var p_3 = $.sibling($.first_child(fragment_5), 3);
			var text_9 = $.only_child(p_3, true);

			$.next();
			$.template_effect(($0) => $.set_text(text_9, $0), [() => $$props.summary.right.join(" ")]);
			$.append($$anchor, fragment_5);
		};

		$.add_svelte_meta(
			() => $.if(node_6, ($$render) => {
				if ($$props.summary.right.length) $$render(consequent_4);
			}),
			'if',
			SessionSummary,
			51,
			2
		);
	}

	var node_7 = $.sibling(node_6, 2);

	{
		var consequent_5 = ($$anchor) => {
			var fragment_6 = root_7();
			var p_4 = $.sibling($.first_child(fragment_6), 3);
			var text_10 = $.only_child(p_4);

			$.next();

			$.template_effect(() => $.set_text(text_10, `
      ${$.strict_equals($$props.summary.dropped, 1)
				? "1 answer was"
				: `${$$props.summary.dropped} answers were`} refused by the server and not counted.
    `));

			$.append($$anchor, fragment_6);
		};

		$.add_svelte_meta(
			() => $.if(node_7, ($$render) => {
				if ($$props.summary.dropped) $$render(consequent_5);
			}),
			'if',
			SessionSummary,
			56,
			2
		);
	}

	var node_8 = $.sibling(node_7, 2);
	var button = $.sibling(node_8, 2);
	let classes;
	var node_9 = $.sibling($.child(button));

	{
		var consequent_6 = ($$anchor) => {
			var kbd = root_8();

			$.append($$anchor, kbd);
		};

		$.add_svelte_meta(
			() => $.if(node_9, ($$render) => {
				if (hints()) $$render(consequent_6);
			}),
			'if',
			SessionSummary,
			66,
			4
		);
	}

	$.next();
	$.reset(button);
	$.bind_this(button, ($$value) => $.set(back, $$value), () => $.get(back));
	$.next();
	$.reset(section);
	$.next();

	$.template_effect(() => {
		$.set_text(text, $$props.summary.setName);
		classes = $.set_class(button, 1, 'svelte-i77pfhz3anbp', null, classes, { pressed: pressed() });
	});

	$.delegated('click', button, function click(e) {
		return $.strict_equals(e.detail, 0, false) && $$props.onback();
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);
import "bun-svelte:SessionSummary.svelte-3177jioiqr045-style.css";